module.exports = __webpack_public_path__ + "static/media/AUSTRALIA-circle.08cb36e1.svg";